import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IUserConfig } from '../interfaces/interfaces';

@Injectable({
  providedIn: 'root',
})
export class UserConfigService {
  private http = inject(HttpClient);

  getConfig(): Observable<IUserConfig> {
    return this.http
      .get<{ config: IUserConfig }>(`${environment.apiUrl}/me/config`, {
        withCredentials: true,
      })
      .pipe(map((response) => response.config));
  }

  updateConfig(config: IUserConfig): Observable<IUserConfig> {
    return this.http
      .put<{
        config: IUserConfig;
      }>(`${environment.apiUrl}/me/config`, config, { withCredentials: true })
      .pipe(map((response) => response.config));
  }
}
